import React, {Component} from 'react';
import {Button, Table, message, Popconfirm, Drawer} from 'antd';
import {connect} from 'react-redux';
import {getOrganization} from '@store/modules/organization';
import {
  queryAddOrg,
  queryConfigOrg,
  queryDeleteOrg,
  queryDisableOrg,
  queryEnableOrg,
  queryUpdateOrg,
} from "@api/core/org";
import FormOrg from './FormOrg';
import FormConfig from './FormConfig';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      detail: {},
      configVisible: false,
    };
  }

  componentWillMount() {
  }

  componentDidMount() {
    this.getOrgTree();
  }

  handleSave = params => {
    if (params.uuid) {
      this.updateOrg(params);
    } else {
      this.addOrg(params);
    }
  };

  configOrg = config => {
    const params = {
      orgUuid: this.uuid,
      orgName: this.orgName,
      config,
    };
    queryConfigOrg(params).then(res => {
      if (res.statusCode === 200) {
        this.handleConfigVisible(false);
        message.success(res.message);
        this.getOrgTree();
      } else {
        message.error(res.message);
      }
    });
  };

  addOrg = params => {
    queryAddOrg(params).then(res => {
      if (res.statusCode === 200) {
        this.handleVisible(false);
        message.success(res.message);
        this.getOrgTree();
      } else {
        message.error(res.message);
      }
    });
  };

  updateOrg = params => {
    queryUpdateOrg(params).then(res => {
      if (res.statusCode === 200) {
        this.handleVisible(false);
        message.success(res.message);
        this.getOrgTree();
      } else {
        message.error(res.message);
      }
    });
  };

  deleteOrg = uuid => {
    queryDeleteOrg({uuid}).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getOrgTree();
      } else {
        message.error(res.message);
      }
    });
  };

  disableOrg = uuid => {
    queryDisableOrg({uuid}).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getOrgTree();
      } else {
        message.error(res.message);
      }
    });
  };

  enableOrg = uuid => {
    queryEnableOrg({uuid}).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getOrgTree();
      } else {
        message.error(res.message);
      }
    });
  };

  getOrgTree = () => {
    const {dispatch} = this.props;
    dispatch(getOrganization());
  };

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  handleConfig = (uuid, orgName) => {
    this.uuid = uuid;
    this.orgName = orgName;
    this.handleConfigVisible(true);
  };

  handleConfigVisible = flag => {
    this.setState({
      configVisible: !!flag,
    });
  };

  handleAdd = detail => {
    this.setState({
      detail,
    });
    this.handleVisible(true);
  };

  handleEdit = record => {
    this.setState({
      detail: record,
    });
    this.handleVisible(true);
  };

  onClose = () => {
    this.handleVisible(false);
  };

  onConfigClose = () => {
    this.handleConfigVisible(false);
  };

  columns = () => {
    return [
      {
        title: '组织名称',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => <a onClick={() => this.handleEdit(record)}>{text}</a>,
      },
      {
        title: '性质',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) =>
          text === 2 ? <span style={{color: 'red'}}>公司</span> : <span>部门</span>,
      },
      {
        title: '备注',
        dataIndex: 'remark',
        key: 'remark',
      },
      {
        title: '操作',
        key: 'done',
        render: (rext, record) => (
          <span>
            <a onClick={() => this.handleConfig(record.uuid, record.name)}>组织配置</a>
            {record.children ? null : (
              <span>
                <span className="ant-divider"/>
                <Popconfirm
                  onConfirm={() => this.deleteOrg(record.uuid)}
                  title="确定删除当前组织吗？"
                  placement="topRight"
                  overlayStyle={{width: 200}}
                >
                  <a className="ant-dropdown-link">删除</a>
                </Popconfirm>
              </span>
            )}
            <span className="ant-divider"/>
            <a
              className="ant-dropdown-link"
              onClick={() => this.handleEdit({parent: record.levelCode})}
            >
              添加
            </a>
            <span className="ant-divider"/>
            {record.status === 1 ? (
              <Popconfirm
                onConfirm={() => this.disableOrg(record.uuid)}
                title="确定禁用当前组织吗？"
                placement="topRight"
                overlayStyle={{width: 200}}
              >
                <a className="ant-dropdown-link">禁用</a>
              </Popconfirm>
            ) : (
              <Popconfirm
                onConfirm={() => this.enableOrg(record.uuid)}
                title="确定禁用当前组织吗？"
                placement="topRight"
                overlayStyle={{width: 200}}
              >
                <a className="ant-dropdown-link">启用</a>
              </Popconfirm>
            )}
          </span>
        ),
      },
    ];
  };

  setClassName = (record, index) => {
    if (record.status === 0) {
      return 'td-gray';
    }
  };

  render() {
    const {gData} = this.props;
    const {visible, detail, configVisible} = this.state;
    return (
      <div>
        <Button
          type="primary"
          icon="plus"
          style={{marginBottom: 15}}
          onClick={() => this.handleAdd({})}
        >
          添加
        </Button>
        <Table
          style={{background: '#fff'}}
          rowSelection={{}}
          columns={this.columns()}
          dataSource={gData}
          pagination={false}
          rowKey="uuid"
          rowClassName={this.setClassName}
        />
        {visible ? (
          <Drawer
            title={detail.uuid ? '组织编辑' : '组织新增'}
            placement="right"
            closable
            visible={visible}
            onClose={this.onClose}
            width={680}
          >
            <FormOrg onSubmit={this.handleSave} detail={detail}/>
          </Drawer>
        ) : null}
        {configVisible ? (
          <Drawer
            title="组织配置"
            placement="right"
            closable
            visible={configVisible}
            onClose={this.onConfigClose}
            width={680}
          >
            <FormConfig onSubmit={this.configOrg} detail={detail} orgUuid={this.uuid}/>
          </Drawer>
        ) : null}
      </div>
    );
  }
}

export default connect(state => ({gData: state.organization}))(Index);



// WEBPACK FOOTER //
// ./src/components/hr/org/Index.js